import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const initialState = {
    epgPopup: null,
    fullScreen: "",
    groups: [],
    h24: Cookies.get("h24") || "HH:MM",
    playingChannel: null,
    playlistEpisodes: [],
    playlist: [],
    timer5: Date.now(),
    timer60: Date.now(),
    volume: 50,
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setEpgPopup: (state, action) => {
            state.epgPopup = action.payload;
        },
        setFullScreen: (state, action) => {
            state.fullScreen = action.payload;
        },
        setGroup: (state, action) => {
            state.groups = action.payload;
        },
        setH24: (state, action) => {
            Cookies.set("h24", action.payload, { expires: 365 });
            state.h24 = action.payload;
        },
        setChannel: (state, action) => {
            state.playingChannel = { ...action.payload };
        },
        setPlaylistEpisodes: (state, action) => {
            state.playlistEpisodes = action.payload;
        },
        setPlaylist: (state, action) => {
            state.playlist = action.payload;
        },
        setTimer5: (state, action) => {
            if (action.payload - state.timer5 > 1000) {
                state.timer5 = action.payload;
            }
        },
        setTimer60: (state, action) => {
            if (action.payload - state.timer60 > 5000) {
                state.timer60 = action.payload;
            }
        },
        setVolume: (state, action) => {
            let newVolume = state.volume + action.payload;
            if ((state.volume >= 100 && newVolume >= 100) || (state.volume <= 0 && newVolume <= 0)) {
                return;
            } else if (newVolume > 100) {
                newVolume = 100;
            } else if (newVolume < 0) {
                newVolume = 0;
            }
            state.volume = newVolume;
        },
    },
});

export const {
    setEpgPopup,
    setFullScreen,
    setGroup,
    setH24,
    setChannel,
    setPlaylistEpisodes,
    setPlaylist,
    setTimer5,
    setTimer60,
    setVolume,
} = settingsSlice.actions;

export default settingsSlice.reducer;
